export default __webpack_public_path__ + "static/media/10.91bfee42.jpg";